module.exports = __webpack_public_path__ + "static/media/updated_figure_cncdatabase.cfcaa527.png";